"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React, { useState, useEffect } from "react"
import SharePageDialog from "../../src/components/common/SharePageDialog"
import PrimaryCTAButton from "./shared/PrimaryCTAButton"
import ShareThisArticleButton from "./shared/ShareThisArticleButton"
import { validateUrl } from "../../src/lib/url/validateUrl"
import * as Sentry from "@sentry/nextjs"
import { contentFieldIsFilled as isFilled } from "../../src/components/content/contentRenderPrimitives"
import type { SliceComponentProps } from "../../src/lib/content/legacyBlockTypes"

type CtaAndShareArticleProps = SliceComponentProps

const CtaAndShareArticle = ({ slice }: CtaAndShareArticleProps) => {
  const [showShareArticleDialog, setShowShareArticleDialog] = useState(false)

  const ctaLinkUrl = isFilled.link(slice.primary.ctalink)
    ? slice.primary.ctalink.url
    : undefined
  const shareLinkUrl = isFilled.link(slice.primary.sharearticlelink)
    ? slice.primary.sharearticlelink.url
    : undefined

  useEffect(() => {
    const ctaUrl = ctaLinkUrl
    const shareUrl = shareLinkUrl

    if (ctaUrl) {
      const validation = validateUrl(ctaUrl)
      if (!validation.valid || validation.warnings.length > 0) {
        const errorMessage = `Malformed CTA URL in CtaAndShareArticle slice: "${ctaUrl}"`
        console.error(errorMessage, validation)
        Sentry.captureException(new Error(errorMessage), {
          level: validation.valid ? "warning" : "error",
          tags: {
            component: "CtaAndShareArticle",
            url_type: "cta_link",
          },
          extra: {
            url: ctaUrl,
            validation,
          },
        })
      }
    }

    if (shareUrl) {
      const validation = validateUrl(shareUrl)
      if (!validation.valid || validation.warnings.length > 0) {
        const errorMessage = `Malformed share URL in CtaAndShareArticle slice: "${shareUrl}"`
        console.error(errorMessage, validation)
        Sentry.captureException(new Error(errorMessage), {
          level: validation.valid ? "warning" : "error",
          tags: {
            component: "CtaAndShareArticle",
            url_type: "share_link",
          },
          extra: {
            url: shareUrl,
            validation,
          },
        })
      }
    }
  }, [ctaLinkUrl, shareLinkUrl])

  const renderShareGroupDialog = () => {
    return (
      <SharePageDialog
        key={"share-article-dialog"}
        open={showShareArticleDialog}
        onClose={() => {
          setShowShareArticleDialog(false)
        }}
        url={
          isFilled.link(slice.primary.sharearticlelink)
            ? slice.primary.sharearticlelink.url
            : ""
        }
        title="Share This Article!"
      />
    )
  }

  return [
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      key={"cta-and-share-article"}
      className={"w-full flex justify-center items-center"}
    >
      <div
        className={
          "font-roboto flex items-center justify-between flex-col min-[600px]:flex-row min-[600px]:w-[445px] mb-[50px] min-[600px]:mb-[60px] h-[117px] mt-[50px] min-[600px]:mt-0"
        }
      >
        <PrimaryCTAButton
          text={
            isFilled.link(slice.primary.ctalink) ? slice.primary.ctalink.text : ""
          }
          href={
            isFilled.link(slice.primary.ctalink) ? slice.primary.ctalink.url : ""
          }
        />
        <ShareThisArticleButton
          onClick={() => {
            setShowShareArticleDialog(true)
          }}
        />
      </div>
    </section>,
    showShareArticleDialog ? renderShareGroupDialog() : null,
  ]
}

export default CtaAndShareArticle
